import { FUND_SETUP_SECTION_IDS } from '~/constants/fundSetupSections'

export const FUND_SETUP_TREE_KEYS = {
  INTRO: {
    id: 'intro',
    namePath: 'sections.introduction.name',
    headerPath: 'sections.introduction.name',
  },
  BASIC_INFO: {
    id: 'basicInfo',
    namePath: 'sections.basicInformation.name',
  },
  SUSTAINABILITY_APPROACH: {
    id: 'sustainabilityApproach',
    namePath: 'sections.sustainabilityApproach.name',
  },
  OUTRO: {
    id: 'outro',
    namePath: 'sections.nextSteps.name',
  },
} as const

export const FUND_SETUP_BASIC_INFO_TABS = [
  {
    id: 'basicInfo_fundManagementCompany',
    namePath: 'sections.basicInformation.fundManagementCompany.name',
    headerPath: 'sections.basicInformation.fundManagementCompany.header',
    contentId: 'fundSetupSectionBasicInfoFundManagementCompany',
    sectionId: FUND_SETUP_SECTION_IDS.BASIC_INFO_COMPANY,
  },
  {
    id: 'basicInfo_fund',
    namePath: 'sections.basicInformation.fund.name',
    headerPath: 'sections.basicInformation.fund.header',
    contentId: 'fundSetupSectionBasicInfoFund',
    sectionId: FUND_SETUP_SECTION_IDS.BASIC_INFO_FUND,
  },
] as const

export const FUND_SETUP_SUSTAINABILITY_BASE_TABS = [
  {
    id: 'sustainabilityApproach_fundManagementCompany',
    namePath: 'sections.sustainabilityApproach.fundManagementCompany.name',
    headerPath: 'sections.sustainabilityApproach.fundManagementCompany.header',
    completionKey: 'entitySustainabilityApproach',
    contentId: 'fundSetupSectionEntitySustainabilityApproach',
    sectionId: FUND_SETUP_SECTION_IDS.ENTITY_SUSTAINABILITY_APPROACH,
  },
  {
    id: 'sustainabilityApproach_fund',
    namePath: 'sections.sustainabilityApproach.fund.name',
    headerPath: 'sections.sustainabilityApproach.fund.header',
    completionKey: 'strategySelection',
    contentId: 'fundSetupSectionStrategySelection',
    sectionId: FUND_SETUP_SECTION_IDS.STRATEGY_SELECTION,
  },
] as const

export const FUND_SETUP_SUSTAINABILITY_OPTIONAL_TABS = {
  ES_CHARACTERISTICS: {
    id: 'sustainabilityApproach_esCharacteristics',
    namePath: 'sections.sustainabilityApproach.sfdrStrategies.esCharacteristics.name',
    headerPath:
      'sections.sustainabilityApproach.sfdrStrategies.esCharacteristics.header',
    completionKey: 'esCharacteristic',
    contentId: 'esCharacteristics',
    sectionId: FUND_SETUP_SECTION_IDS.ES_CHARACTERISTIC,
  },
  SUSTAINABILITY_RISK: {
    id: 'sustainabilityApproach_sustainabilityRisk',
    namePath: 'sections.sustainabilityApproach.sustainabilityRisks.name',
    headerPath: 'sections.sustainabilityApproach.sustainabilityRisks.header',
    completionKey: 'sustainabilityRisk',
    contentId: 'fundSetupSectionSustainabilityRisk',
    sectionId: FUND_SETUP_SECTION_IDS.SUSTAINABILITY_RISK,
  },
} as const

export const FUND_SETUP_ANCILLARY_SECTIONS = {
  PAI: {
    id: 'pai',
    namePath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.pai.name',
    headerPath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.pai.header',
    completionKey: 'pai',
    contentId: 'fundSetupSectionPai',
    sectionId: FUND_SETUP_SECTION_IDS.PAI,
    introComponentId: 'sfdrPaiSetupIntro',
    introComponent: 'sfdr-pai-setup-intro',
  },
  KFW: {
    id: 'kfw',
    namePath: 'sections.kfwReporting.name',
    headerPath: 'sections.kfwReporting.header',
    completionKey: 'kfw',
    contentId: 'fundSetupSectionKfw',
    sectionId: FUND_SETUP_SECTION_IDS.KFW,
  },
  HIDDEN_KPIS: {
    id: 'hiddenKpis',
    namePath: 'sections.hiddenKpis.name',
    headerPath: 'sections.hiddenKpis.header',
    contentId: 'fundSetupSectionHiddenKpis',
    sectionId: FUND_SETUP_SECTION_IDS.HIDDEN_KPIS,
    introComponentId: 'hiddenKpisIntro',
    introComponent: 'hidden-kpis-intro',
  },
  GENERAL_KPIS: {
    id: 'generalKpis',
    namePath: 'sections.generalKpis.name',
    headerPath: 'sections.generalKpis.header',
    contentId: 'fundSetupSectionGeneralKpis',
    sectionId: FUND_SETUP_SECTION_IDS.GENERAL_KPIS,
    introComponentId: 'generalKpisIntro',
    introComponent: 'general-kpis-intro',
  },
} as const

export const FUND_SETUP_SUSTAINABLE_OBJECTIVE_TREE = {
  CONTAINER: {
    id: 'sustainabilityApproach_sfdrStrategies',
    namePath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.name',
    completionKey: 'sustainableObjectiveSection',
  },
  SELECT: {
    id: 'sustainabilityApproach_sfdrStrategies_select',
    namePath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.select.name',
    headerPath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.select.header',
    contentId: 'sustainableObjectivesList',
    component: 'sfdr-sustainable-objectives-list',
    sectionId: FUND_SETUP_SECTION_IDS.SUSTAINABLE_OBJECTIVE_LIST,
  },
  EDIT: {
    idPrefix: 'sustainabilityApproach_sfdrStrategies_edit',
    contentIdPrefix: 'sustainableObjectiveForm_',
    namePath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.edit.name',
    headerPath:
      'sections.sustainabilityApproach.sfdrStrategies.sustainableInvestmentObjective.edit.header',
    sectionId: FUND_SETUP_SECTION_IDS.SUSTAINABLE_OBJECTIVE_TEMPLATE,
  },
} as const
